window.$OneSignal = window.OneSignal = window.OneSignal || [];

OneSignal.push(['init', {
  "appId": "3eabd441-e65a-4544-b827-5bd5492aa4c8",
  "allowLocalhostAsSecureOrigin": true,
  "welcomeNotification": {
    "disable": false
  }
}]);

export default function (ctx, inject) {
  inject('OneSignal', OneSignal)
}
